import {createReducer} from '@reduxjs/toolkit';
import {
  selectCollectionId,
  selectCollectionFeatureRef,
} from '@src/actions/featureCollections.ts';
import {type FeatureCollectionId} from '@src/types/featureCollections.ts';

type FeatureCollectionsState = {
  selectedId: FeatureCollectionId | null;
  selectedFeatureRef: FeatureCollectionId | null;
};

export const initialState: FeatureCollectionsState = {
  // The hash ID of the currently selected collection.
  selectedId: null,

  // The reference of the currently selected feature.
  selectedFeatureRef: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(selectCollectionId, (state, {payload}) => {
    state.selectedId = payload ?? null;
  });

  builder.addCase(selectCollectionFeatureRef, (state, {payload}) => {
    state.selectedFeatureRef = payload ?? null;
  });
});
